import { Button } from "@triumph/design-system"
import { DataTable } from "@/app/shared/components/DataTable/DataTable"
import { BillingReminder } from "../billingReminder.types"
import { useTranslation } from "react-i18next"
import { BillingReminderTableWrapper, ButtonFooter } from "./PastDueInvoices.StyledComponents"
import { pastDueInvoicesTableColumn } from "./PastDueInvoicesTableColumn"
import { TableTitleHeader } from "@/app/shared/components/DataTable/Components/TableTitleHeader"
import { ButtonsWrapper, SubmitButton } from "../PendingInvoicesTable/PendingInvoices.StyledComponents"

interface PastDueInvoicesTableProps {
    isSubmitDisabled: (boolean)
    totalInvoices: (number)
    rows: BillingReminder[]
    handleFormSubmit: () => void
    handleNotesChange: (invoiceNumber: string, includeDisputedReasons: boolean) => void
    handlePaymentDateChange: (invoiceNumber: string, selectedPaymentDate: string) => void
    toggleUnableToSubmitMessage: (showErrorMessage: boolean) => void
}

export const PastDueInvoicesTable = ({
    isSubmitDisabled,
    totalInvoices,
    rows,
    handleFormSubmit,
    handleNotesChange,
    handlePaymentDateChange,
    toggleUnableToSubmitMessage
}: PastDueInvoicesTableProps ) => {

    const { t } = useTranslation('billingReminder');
    
    const columnFormat = pastDueInvoicesTableColumn({
        handleNotesChange,
        handlePaymentDateChange,
    });
    return (
        <div>
            <BillingReminderTableWrapper>
                <TableTitleHeader 
                    title={`Past Due REQUIRED (${totalInvoices > 10 ? '10 of '+ totalInvoices: totalInvoices})`}
                />
                <DataTable
                    data={rows ?? []}
                    columns={columnFormat}
                    isShowOverflow={true}
                    textWrapMode={2}
                    alternateRowColor={false}
                    maxHeight="none"
                />
            </BillingReminderTableWrapper>
            <ButtonFooter>
                <ButtonsWrapper onClick={()=>toggleUnableToSubmitMessage(isSubmitDisabled)}>
                    <SubmitButton>
                        <Button 
                            disabled={isSubmitDisabled}
                            type="submit" 
                            onClick={() => {handleFormSubmit()}}
                        >
                            {t('button.submit')}
                        </Button>
                    </SubmitButton>
                </ButtonsWrapper>
            </ButtonFooter>
        </div>
    )
}